import { render } from "./PendingOrdersList.vue?vue&type=template&id=09481dac"
import script from "./PendingOrdersList.vue?vue&type=script&lang=js"
export * from "./PendingOrdersList.vue?vue&type=script&lang=js"

import "./PendingOrdersList.vue?vue&type=style&index=0&id=09481dac&lang=scss"

import exportComponent from "/Users/vinit.kariatukaran/hofmp-hp/hofmp/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__